import { createFileRoute, redirect } from "@tanstack/react-router";
import { AccountSettings } from "@/components/settings/AccountSettings";
import { hasActiveSession } from "@/lib/auth";
import { saveRedirect } from "@/lib/storage-utils";
import { noindexHead } from "@/lib/seo";

export const Route = createFileRoute("/account/settings")({
  component: AccountSettings,
  head: () => noindexHead("Account Settings | Lutely"),
  beforeLoad: async ({ location }) => {
    const isAuthenticated = await hasActiveSession(); // todo handle stale pool state
    if (!isAuthenticated) {
      saveRedirect(location.href);
      throw redirect({
        to: "/",
        search: { auth: "login" as const },
      });
    }
  },
});
